import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Text } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	icon: IconType;
	title: string;
	subtitle?: string;
};

export const CardIconHeader = ({ icon, title, subtitle }: Props) => {
	const theme = useAppTheme();
	return (
		<Box flexDirection="row" alignItems="center" gap={12}>
			<Box
				width={44}
				height={44}
				borderRadius={1000}
				backgroundColor={theme.colors.surfaceVariant}
				alignItems="center"
				justifyContent="center"
			>
				<Icon name={icon} size={22} color={theme.colors.onSurfaceVariant} />
			</Box>
			<Box flex={1} gap={2}>
				<Text variant="titleMedium">{title}</Text>
				{subtitle ? (
					<Text
						variant="bodySmall"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{subtitle}
					</Text>
				) : null}
			</Box>
		</Box>
	);
};
